<twc-global-search
  [results]="results()"
  (searchValueChanged)="onSearchValueChanged($event)"
></twc-global-search>

<ng-template #shipmentTemplateRef let-option="option">
  <lig-shipment-search-option [option]="option"></lig-shipment-search-option>
</ng-template>

<ng-template #quoteTemplateRef let-option="option">
  <lig-ltl-quote-search-option [option]="option"></lig-ltl-quote-search-option>
</ng-template>
